import $ from "jquery";
import {
    setLangs,
    aboutBrow,
    getId,
    isFunction
} from "../../funcs";
import BaseApp from "../BaseApp";
import UserProfileChannel from "./UserProfileChannel";
import UserProfileView from "./view/UserProfileView";
import RowsStorage from "../../classes/storage/RowsStorage";
import Api from "../../classes/api/Api";
import FilesApi from "../../classes/api/FilesApi";
import UIModal from "../../classes/modals/UIModal";
import "plugins/focusManager";
import {getValidationErrorInEmail} from "../../shared/email/getValidationErrorInEmail";

const LIST_USER = RowsStorage.get("LIST_USER");
const USER_LANG = RowsStorage.get("USER_LANG");

export default class UserProfileApp extends BaseApp {
    channel() {return UserProfileChannel;}
    channelEvents() {
        return {
            toggle: "onChannelToggle",
            show: "onChannelShow",
            hide: "onChannelHide"
        };
    }

    onReady() {
        let userModel = system.user.model;
        setLangs(USER_LANG.collection.models);

        this.view = new UserProfileView({
            model: userModel
        });
        this.view.$el.appendTo("body");
        this.view.render();

        this.listenTo(this.view, "enter:phone1", this.onEnterValue.bind(this, "PHONE1"));
        this.listenTo(this.view, "enter:phone2", this.onEnterValue.bind(this, "PHONE2"));
        this.listenTo(this.view, "enter:email", this.onEnterValue.bind(this, "USER_EMAIL"));
        this.listenTo(this.view, "enter:image", this.onEnterImage.bind(this));
        this.listenTo(this.view, "savePassword", this.onSavePassword.bind(this));
        this.listenTo(this.view, "changed:lang", (ev) => this.onChangeLang(ev));

        this.view.$el.focusManager({
            check: ".menu-profile, .drag-modal.success, select",
            onBlur: () => {
                this.view.$el.removeClass("showed");
            }
        });
    }

    onChannelToggle() {
        if ( this.view.$el.hasClass("showed") ) {
            this.onChannelHide();
        } else {
            this.onChannelShow();
        }
    }

    onChannelShow() {
        this.view.show();
    }

    onChannelHide() {
        this.view.hide();
    }

    async onEnterValue(key, value, callback) {
        if ( !isFunction(callback) ) {
            callback = function() {
            };
        }

        const isValidValue = this.validateEnteredValue(key, value);
        if ( !isValidValue ) {
            return;
        }

        let userModel = LIST_USER.collection.get(system.user.id);
        if ( !userModel ) {
            LIST_USER.get(system.user.id);
            return;
        }

        if ( userModel.get(key) == value ) {
            return;
        }

        this.view.waitUpdate();
        let changes = {};
        changes[key] = value;

        this.view.model = await LIST_USER.update(system.user.id, changes);

        setTimeout(() => {
            this.view.unwaitUpdate();
            callback();
        }, 500);
    }

    validateEnteredValue(key, value) {
        if ( key === "USER_EMAIL" ) {
            const err = getValidationErrorInEmail(value);

            if ( err ) {
                UIModal.error(err);
                this.clearEmailInput();

                return false;
            }
        }
        return true;
    }

    clearEmailInput() {
        const { ui } = this.view;
        const emailInput = ui.$email[0];

        emailInput.value = "";
    }

    async onSavePassword(password) {
        this.view.waitUpdate();

        const response = await Api.request({
            entity: "user",
            method: "changePassword",
            data: {
                id: system.user.id,
                password,
                deviceType: aboutBrow().isMobile ? "mobile" : "desktop"
            }
        });
        $.cookie("token", response.token);

        setTimeout(() => {
            this.view.unwaitUpdate();
            UIModal.success({
                title: "user_profile_password_success_change_title",
                text: "user_profile_password_success_change_text"
            });
        }, 500);
    }

    onEnterImage(file) {
        FilesApi.uploadFiles(file, (err, files) => {
            if ( err || !files.length ) {
                return;
            }

            file = files[0];
            this.onEnterValue("ID_SYS_FILES_PHOTO", getId(file), () => {
                this.view.render();
            });
        });
    }

    async onChangeLang(langId) {
        await LIST_USER.update(system.user.id, {
            ID_LANG: langId
        });

        let langModel = USER_LANG.collection.get(langId);
        let code = langModel.get("CODE");
        $.cookie("lang", code);
        window.location.reload();
    }
}
